import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const courseDiscussionCommentApi = createAsyncThunk(
    'auth/courseDiscussionComments',
    async (data, { rejectWithValue }) => {
        try {
            const commentId = data?.post_id || data?.comment_id || '';
            const response = await AuthAxios.get(`/api/v1/discussion/comments/${commentId}/replies/`, { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }

const courseDiscussionCommentSlice = createSlice({
    name: 'courseDiscussionComment list',
    initialState: intialState,
    reducers: {
        resetCourseDiscussionComment: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(courseDiscussionCommentApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseDiscussionCommentApi.fulfilled, (state, action) => {
            state.loading = false
            let resArray = action?.payload?.results?.results || action?.payload?.result?.comments || action?.payload?.results || action?.payload?.result || [];
            if (!Array.isArray(resArray)) resArray = [];
            state.result = resArray;
            state.message = action?.payload?.message || action?.payload?.results?.message;
            state.total = action?.payload?.comment_count || action?.payload?.count || action?.payload?.results?.total_comments || action?.payload?.total || 0;
        })
        builder.addCase(courseDiscussionCommentApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const { resetCourseDiscussionComment } = courseDiscussionCommentSlice.actions
export const courseDiscussionCommentReducer = courseDiscussionCommentSlice.reducer
